import {
  DefaultDataServiceConfig,
  HttpUrlGenerator,
  QueryParams,
} from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Update } from '@ngrx/entity';
import { PlDataService } from 'pl-core-services';

export class TransformingDataService<T, J> extends PlDataService<T> {
  private readonly fromJSON: (c: T) => T;

  private readonly toJSON: (c: T) => T;

  constructor(
    entityName: string,
    httpClient: HttpClient,
    httpUrlGenerator: HttpUrlGenerator,
    fromJSON: (s: J) => T,
    toJSON: (c: T) => J,
    config?: DefaultDataServiceConfig
  ) {
    super(entityName, httpClient, httpUrlGenerator, config);
    this.fromJSON = fromJSON as unknown as (c: T) => T;
    this.toJSON = toJSON as unknown as (c: T) => T;
  }

  override getAll(): Observable<T[]> {
    return super.getAll().pipe(map((clients) => clients.map(this.fromJSON)));
  }

  override getById(id: string | number): Observable<T> {
    return super.getById(id).pipe(map(this.fromJSON));
  }

  override getWithQuery(params: string | QueryParams): Observable<T[]> {
    return super.getWithQuery(params).pipe(
      // NOTE: use `data: any` to allow runtime values: (C[] | { results: C[], ... })
      map((data: any) => {
        if (!data) {
          return [];
        }
        const list = data.results || data;
        return list.map(this.fromJSON);
      })
    );
  }

  override add(client: T): Observable<T> {
    return super
      .add(this.toJSON(client))
      .pipe(map((clientR) => this.fromJSON(clientR)));
  }

  override update(update: Update<T>): Observable<T> {
    const changes = this.toJSON(update.changes as T) as Partial<T>;
    return super
      .update({ id: update.id, changes } as Update<T>)
      .pipe(map((clientR) => this.fromJSON(clientR)));
  }

  override upsert(client: T): Observable<T> {
    return super.upsert(this.toJSON(client));
  }
}
